import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Nazione", -1)
const _hoisted_3 = ["readonly", "disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Seleziona nazione ", -1)
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_form_input, {
      type: "text",
      label: "Name",
      readonly: _ctx.readonly,
      modelValue: _ctx.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.name) = $event)),
      placeholder: "Name"
    }, null, 8, ["readonly", "modelValue"]),
    _createVNode(_component_form_input, {
      type: "text",
      label: "Surname",
      readonly: _ctx.readonly,
      modelValue: _ctx.value.surname,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.surname) = $event)),
      placeholder: "Surname"
    }, null, 8, ["readonly", "modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.nazione) = $event)),
        readonly: _ctx.readonly,
        disabled: _ctx.readonly
      }, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nazioni, (item, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: item.alpha2Code
          }, _toDisplayString(item.name), 9, _hoisted_5))
        }), 128))
      ], 8, _hoisted_3), [
        [_vModelSelect, _ctx.value.nazione]
      ])
    ]),
    (_ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
      ? (_openBlock(), _createBlock(_component_form_input, {
          key: 0,
          type: "text",
          label: "Url immagine profilo",
          readonly: _ctx.readonly,
          modelValue: _ctx.value.profilePicture,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.profilePicture) = $event)),
          placeholder: "ProfilePicture"
        }, null, 8, ["readonly", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}